import React, { Component } from "react";
import Nav from "../../components/nav/Nav";
import { bindActionCreators } from "redux";

import { connect } from "react-redux";
import {
  ListGroup,
  ListGroupItem,
  ListGroupItemText,
  Alert,
  Jumbotron,
} from "reactstrap";

import Asbestos from "./templates/Asbestos";
import Biological from "./templates/Biological";
import Environmental from "./templates/Environmental";
import Ergonomic from "./templates/Ergonomic";
import ManagementOfChange from "./templates/ManagementOfChange";
import OccupationalHealthAndSafety from "./templates/OccupationalHealthAndSafety";
import RouteRiskAssessment from "./templates/RouteRiskAssessment";

import {
  ASBESTOS,
  BIOLOGICAL,
  ENVIRONMENTAL,
  ERGONOMIC,
  MANAGEMENT_OF_CHANGE,
  OCCUPATIONAL_HEALTH_AND_SAFETY,
  ROUTE_RISK_ASSESSMENT,
} from "./Constants";

import { getStoredData, storeData, removeDataFromStorage } from "../../Helpers";

import { create as createRisk } from "../../services/risk";

import Spinner from "../../components/spinner/Spinner";
import env from "../../env";

class Form extends Component {
  constructor() {
    super();
    this.state = {
      creating: false,
      created: false,
      loading: true,
      form: null,
      name: "",
      error: null,
      template_id: "",
      occupational_health: [
        {
          ...OCCUPATIONAL_HEALTH_AND_SAFETY,
        },
      ],
      management_of_change: [{ ...MANAGEMENT_OF_CHANGE }],
      ergonomic: [{ ...ERGONOMIC }],
      biological: [{ ...BIOLOGICAL }],
      environmental: [{ ...ENVIRONMENTAL }],
      asbestos: [{ ...ASBESTOS }],
      route_risk_assessment: [{ ...ROUTE_RISK_ASSESSMENT }],
    };
  }

  onChange = (event) => {
    const { name: targetName, value } = event.target;

    // If the template_id is changed, load the data for that template
    if (targetName === "template_id") {
      const templateData = this.getDataForTemplate(value);
      this.setState({ [targetName]: value, ...templateData });
    } else {
      this.setState({ [targetName]: value });
    }
  };

  // New method to load data for the selected template
  getDataForTemplate = (template_id) => {
    const type =
      template_id === "occupational_health_and_safety"
        ? "occupational_health"
        : template_id;
    const data = getStoredData(type);

    if (data) {
      const parsed = JSON.parse(data);
      return {
        name: parsed.name || "",
        [type]: parsed.data || this.state[type],
      };
    }
    return { name: "" };
  };

  componentDidMount() {
    const { loggedIn } = this.props.account;

    if (!loggedIn) {
      this.props.history.push(`${env.url}/login`);
    }
  }

  rates = () => {
    return {
      1: "None",
      2: "Low",
      3: "Average",
      4: "High",
      5: "Extremely",
    };
  };

  addActivity = () => {
    const { template_id } = this.state;
    let data = null;

    switch (template_id) {
      case "occupational_health_and_safety":
        data = this.state.occupational_health;
        this.setState({
          occupational_health: [
            ...data,
            ...[{ ...OCCUPATIONAL_HEALTH_AND_SAFETY }],
          ],
        });
        break;
      case "management_of_change":
        data = this.state.management_of_change;
        this.setState({
          management_of_change: [...data, ...[{ ...MANAGEMENT_OF_CHANGE }]],
        });
        break;
      case "ergonomic":
        data = this.state.ergonomic;
        this.setState({
          ergonomic: [...data, ...[{ ...ERGONOMIC }]],
        });
        break;
      case "biological":
        data = this.state.biological;
        this.setState({
          biological: [...data, ...[{ ...BIOLOGICAL }]],
        });
        break;
      case "environmental":
        data = this.state.environmental;
        this.setState({
          environmental: [...data, ...[{ ...ENVIRONMENTAL }]],
        });
        break;
      case "asbestos":
        data = this.state.asbestos;
        this.setState({
          asbestos: [...data, ...[{ ...ASBESTOS }]],
        });
        break;
      case "route_risk_assessment":
        data = this.state.route_risk_assessment;
        this.setState({
          route_risk_assessment: [...data, ...[{ ...ROUTE_RISK_ASSESSMENT }]],
        });
        break;
    }
  };

  onUpdate = (type, key, name, value) => {
    if (type === "occupational_health_and_safety") type = "occupational_health";

    let data = this.state[type];

    if (data) {
      data[key][name] = value;
      this.setState({
        [type]: [...data],
        error: null,
      });
    }
  };

  canSubmit(type, data) {
    let success = false;
    let complete = true;
    let keys = [];

    switch (type) {
      case "occupational_health":
        keys = Object.keys(OCCUPATIONAL_HEALTH_AND_SAFETY);
        break;
      case "management_of_change":
        keys = Object.keys(MANAGEMENT_OF_CHANGE);
        break;
      case "ergonomic":
        keys = Object.keys(ERGONOMIC);
        break;
      case "biological":
        keys = Object.keys(BIOLOGICAL);
        break;
      case "environmental":
        keys = Object.keys(ENVIRONMENTAL);
        break;
      case "asbestos":
        keys = Object.keys(ASBESTOS);
        break;
      case "route_risk_assessment":
        keys = Object.keys(ROUTE_RISK_ASSESSMENT);
        break;
    }

    if (keys.length) {
      for (let i = 0; i < data.length; i++) {
        for (let j in keys) {
          if (!data[i][keys[j]]) {
            complete = false;
            break;
          }
        }
      }

      success = complete;
    }

    if (success && !this.state.name) success = false;

    return success;
  }

  gotToList = () => {
    this.props.history.push(`${env.url}/risks/list/`);
  };

  onSubmit = () => {
    const { template_id, name } = this.state;
    let type = template_id;
    if (type === "occupational_health_and_safety") type = "occupational_health";

    let data = this.state[type];

    if (this.canSubmit(type, data)) {
      const { site } = this.props.account;

      this.setState({ creating: true });

      createRisk({
        data: data,
        mine_id: site.id,
        type: template_id,
        name: name,
      })
        .then((response) => {
          removeDataFromStorage(type);
          this.gotToList();
        })
        .catch((error) => {})
        .finally(() => {
          //this.setState({creating: true});
        });
    } else {
      this.setState({ error: "Please fill in all the required fields!" });
    }
  };

  onSave = () => {
    const { template_id, name } = this.state;
    let type = template_id;
    if (type === "occupational_health_and_safety") type = "occupational_health";

    let data = this.state[type];

    storeData(type, JSON.stringify({ data, name }));
    this.setState({ template_id: null });
  };

  removeActivity = (type, key) => {
    if (type === "occupational_health_and_safety") type = "occupational_health";

    let data = this.state[type];

    if (data) {
      data = data.slice(0, key).concat(data.slice(key + 1, data.length));
      this.setState({
        [type]: [...data],
        error: null,
      });
    }
  };

  // Method to check if there's saved data for the given template
  hasSavedData = (templateId) => {
    const type =
      templateId === "occupational_health_and_safety"
        ? "occupational_health"
        : templateId;
    const data = getStoredData(type);
    return data !== null;
  };

  render() {
    const {
      creating,
      error,
      template_id,
      occupational_health,
      ergonomic,
      management_of_change,
      biological,
      environmental,
      asbestos,
      route_risk_assessment,
      name,
    } = this.state;

    const { site } = this.props.account;

    const templates = {
      occupational_health_and_safety: "Occupational health and safety template",
      management_of_change: "MOC (Management of Change)",
      ergonomic: "Ergonomic template",
      biological: "Biological template",
      environmental: "Environmental template",
      asbestos: "Asbestos template",
      route_risk_assessment: "Route risk assessment template",
    };

    const rates = this.rates();

    return (
      <div className="risk-form">
        <div id="Popover" />
        {creating ? (
          <Spinner message="Submitting risk assessment" overlay={true} />
        ) : null}

        <Nav location={this.props.location} history={this.props.history} />

        {!template_id && (
          <Jumbotron>
            <p className="lead">{site ? site.name : ""} Risk Assessments</p>
            <hr className="my-2" />
            <p>Click on a template to complete it</p>
          </Jumbotron>
        )}

        {template_id && (
          <Jumbotron>
            <p className="lead">
              Complete Risk Assessment: {templates[template_id]}
            </p>
          </Jumbotron>
        )}

        <div className="form-holder">
          <div className="inner">
            {!template_id && (
              <div className="col-xs-12">
                <div className="form-group">
                  <ListGroup>
                    {Object.keys(templates).map((key) => {
                      const isSaved = this.hasSavedData(key);
                      return (
                        <ListGroupItem
                          style={isSaved ? { backgroundColor: "#17a2b8" } : {}}
                          tag="a"
                          action
                          key={key}
                          onClick={() =>
                            this.onChange({
                              target: { name: "template_id", value: key },
                            })
                          }
                        >
                          <ListGroupItemText>
                            {isSaved && (
                              <span
                                style={{
                                  position: "absolute",
                                  top: "0",
                                  color: "#fff",
                                  fontSize: "10px",
                                  right: "2px",
                                }}
                              >
                                Saved. Click to continue.
                              </span>
                            )}
                            <span>{templates[key]}</span>
                          </ListGroupItemText>
                        </ListGroupItem>
                      );
                    })}
                  </ListGroup>
                </div>
              </div>
            )}

            {error ? (
              <Alert
                style={{
                  position: "fixed",
                  zIndex: "100",
                  right: "0",
                  top: "100px",
                  minWidth: "400px",
                }}
                color="danger"
              >
                {error}
              </Alert>
            ) : null}

            {template_id ? (
              <div>
                <div className="form-group">
                  <label htmlFor="name" className="control-label required">
                    Name
                  </label>
                  <input
                    onChange={this.onChange}
                    className="form-control required"
                    type="text"
                    name="name"
                    id="name"
                    value={name}
                  />
                </div>

                {template_id === "occupational_health_and_safety"
                  ? occupational_health.map((data, key) => (
                      <OccupationalHealthAndSafety
                        data={data}
                        key={key}
                        position={key}
                        removeActivity={this.removeActivity}
                        update={this.onUpdate}
                        type={"occupational_health_and_safety"}
                        rates={rates}
                      />
                    ))
                  : null}

                {template_id === "management_of_change"
                  ? management_of_change.map((data, key) => (
                      <ManagementOfChange
                        data={data}
                        update={this.onUpdate}
                        removeActivity={this.removeActivity}
                        key={key}
                        position={key}
                        type={"management_of_change"}
                        rates={rates}
                      />
                    ))
                  : null}

                {template_id === "ergonomic"
                  ? ergonomic.map((data, key) => (
                      <Ergonomic
                        data={data}
                        key={key}
                        removeActivity={this.removeActivity}
                        position={key}
                        update={this.onUpdate}
                        type={"ergonomic"}
                        rates={rates}
                      />
                    ))
                  : null}

                {template_id === "biological"
                  ? biological.map((data, key) => (
                      <Biological
                        data={data}
                        removeActivity={this.removeActivity}
                        position={key}
                        update={this.onUpdate}
                        key={key}
                        type={"biological"}
                        rates={rates}
                      />
                    ))
                  : null}

                {template_id === "environmental"
                  ? environmental.map((data, key) => (
                      <Environmental
                        data={data}
                        removeActivity={this.removeActivity}
                        position={key}
                        key={key}
                        update={this.onUpdate}
                        type={"environmental"}
                        rates={rates}
                      />
                    ))
                  : null}

                {template_id === "asbestos"
                  ? asbestos.map((data, key) => (
                      <Asbestos
                        data={data}
                        key={key}
                        removeActivity={this.removeActivity}
                        position={key}
                        update={this.onUpdate}
                        type={"asbestos"}
                        rates={rates}
                      />
                    ))
                  : null}
                {template_id === "route_risk_assessment"
                  ? route_risk_assessment.map((data, key) => (
                      <RouteRiskAssessment
                        data={data}
                        key={key}
                        removeActivity={this.removeActivity}
                        position={key}
                        update={this.onUpdate}
                        type={"route_risk_assessment"}
                        rates={rates}
                      />
                    ))
                  : null}
                <div
                  className="actions"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <button
                      onClick={this.onSubmit}
                      className="btn btn-success"
                      type="button"
                      id="submit"
                    >
                      Submit
                    </button>
                    <button
                      onClick={this.onSave}
                      className="btn btn-warning"
                      style={{ marginLeft: "8px" }}
                      type="button"
                      id="save-only"
                    >
                      Save
                    </button>
                  </div>
                  <div>
                    <button
                      onClick={() => this.setState({ template_id: null })}
                      className="btn"
                      style={{ marginRight: "8px" }}
                      type="button"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={this.addActivity}
                      className="btn btn-info"
                      type="button"
                    >
                      Add Activity
                    </button>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ account }) => ({
  account,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Form);



// WEBPACK FOOTER //
// ./src/screens/risks/Form.js